import { Button } from "@material-ui/core";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

export default function BackButton() {
  return (
    <Button 
      variant="text" 
      color="primary"
      onClick={() => window.history.back()}
      startIcon={<ArrowBackIcon />}
      style={{
        fontWeight: "bold",
      }}
    >
      Retour
    </Button>
  )
}